'use client';

import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useEffect, useState } from 'react';

export default function Hidden(props: any) {
  const {
    children,
    xsUp,
    xsDown,
    smUp,
    smDown,
    mdUp,
    mdDown,
    lgUp,
    lgDown,
    xlUp,
    xlDown,
  } = props;

  const theme = useTheme();
  const [mounted, setMounted] = useState(false);

  const matches = {
    xsUp: useMediaQuery(theme.breakpoints.up('xs'), { noSsr: true }),
    xsDown: useMediaQuery(theme.breakpoints.down('xs'), { noSsr: true }),
    smUp: useMediaQuery(theme.breakpoints.up('sm'), { noSsr: true }),
    smDown: useMediaQuery(theme.breakpoints.down('sm'), { noSsr: true }),
    mdUp: useMediaQuery(theme.breakpoints.up('md'), { noSsr: true }),
    mdDown: useMediaQuery(theme.breakpoints.down('md'), { noSsr: true }),
    lgUp: useMediaQuery(theme.breakpoints.up('lg'), { noSsr: true }),
    lgDown: useMediaQuery(theme.breakpoints.down('lg'), { noSsr: true }),
    xlUp: useMediaQuery(theme.breakpoints.up('xl'), { noSsr: true }),
    xlDown: useMediaQuery(theme.breakpoints.down('xl'), { noSsr: true }),
  };

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) return null;

  let shouldHide = false;

  if (xsUp && matches.xsUp) shouldHide = true;
  if (xsDown && matches.xsDown) shouldHide = true;
  if (smUp && matches.smUp) shouldHide = true;
  if (smDown && matches.smDown) shouldHide = true;
  if (mdUp && matches.mdUp) shouldHide = true;
  if (mdDown && matches.mdDown) shouldHide = true;
  if (lgUp && matches.lgUp) shouldHide = true;
  if (lgDown && matches.lgDown) shouldHide = true;
  if (xlUp && matches.xlUp) shouldHide = true;
  if (xlDown && matches.xlDown) shouldHide = true;

  if (shouldHide) return null;

  return <>{children}</>;
}
